export let data = {
  header: [
    {
      nav: [
        {
          Name: "Contact Us",
          Url: "https://www.ageco.co.uk/contact-us/",
        },
        {
          Name: "About Age Co",
          Url: "https://www.ageco.co.uk/about-us/",
        },
        {
          Name: "Other Age Co Products",
          Url: "https://www.ageco.co.uk",
        },
        {
          Name: "Useful articles",
          Url: "https://www.ageco.co.uk/useful-articles/",
        },
      ],
      headerBlocks: [
        {
          phone: "0800 022 3243*",
          openingHours: "Mon-Fri 9am-6pm, Sat 9am-12pm",
          content: "",
        },
        {
          phone: "",
          openingHours: "",
          content:
            "Age Co is 100% owned by Age UK and gives its profits to the charity. In the financial year 2021-2022 Age Co donated £4m to Age UK.",
        },
        {
          phone: "",
          openingHours: "",
          content:
            "Age Co Funeral Plans are provided by Dignity Funerals Limited.",
        },
      ],
    },
  ],
  banner: [
    {
      title: "Age Co Prepaid Funeral Plans",
      subtitle: "Age Co is not currently selling new Prepaid Funeral Plans",
    },
  ],
  introCopy:
    "We stopped selling new Prepaid Funeral Plans on 30th June 2022, ahead of regulatory changes.\n\nIf you have an existing Age Co Funeral Plan, please see the Frequently Asked Questions below. If you have any further questions about your plan, please contact the Age Co team at Dignity on 0800 022 3243* or email agecofuneralplan@dignityuk.co.uk.",
  faqs: [
    {
      title: "Frequently Asked Questions",
      questions: [
        {
          question: "Regulation of the Funeral Plan Sector",
          answer:
            "The Financial Conduct Authority (FCA) began regulating the pre-paid funeral plans sector on 29th July 2022, which means that funeral plan providers in the UK must be granted authorisation in order to sell and administer funeral plans.\n\nExisting Age Co Funeral Plans are provided and administered by Dignity Funerals Limited. Dignity Funerals Limited is authorised and regulated by the Financial Conduct Authority under firm reference number 967130.",
        },
        {
          question:
            "How will regulation affect my Age UK / Age Co Funeral Plan?",
          answer:
            "All money paid toward one of our funeral plans is now additionally protected by the Financial Services Compensation Scheme (FSCS).\n\nThis money remains safe in the ‘Trust for Age UK Funeral Plans’. The Trust itself is a separate legal entity, ring-fenced, and remains completely independent of Dignity, the network of Funeral Directors and Age Co. This means the money is secure and unaffected by anything that may otherwise impact the associated companies.\n\nAll existing planholders will benefit from the same regulatory protections as any new customers. For example, complaints or concerns may be escalated to the Financial Ombudsman Service (FOS) should any disputes remain unresolved. More information can be found at www.financial-ombudsman.org.uk.",
        },
        {
          question:
            "Where can I find information about where my money is invested?",
          answer:
            "The trustees ensure the money is prudently managed. You can find more details in the Solvency Assessment Report on the Dignity website.",
        },
        {
          question: "When will I receive a funeral plan statement?",
          answer:
            "All Age Co customers will be provided with a funeral plan statement by 31st August 2023. This statement will clearly set out:\n\n- the total cost of your plan and the amount paid to date\n- a brief summary of what is included and excluded in your plan\n- how you can make changes to your plan\n- how you can cancel your plan.",
        },
      ],
    },
  ],
  footerCopy:
    "* If you call the 0800 number, you will be speaking to Dignity. Calls may be recorded for monitoring and quality purposes.\n\nAge Co Funeral Plans are provided by Dignity Funerals Limited. Dignity Funerals Limited is a company registered in England No. 00041598. VAT registered No. 486 6081 14. Registered office: 4 King Edwards Court, King Edwards Square, Sutton Coldfield B73 6AP. Dignity Funerals Limited is authorised and regulated by the Financial Conduct Authority under Firm Reference Number 967130. AgeCo Limited is a trading subsidiary of Age UK (registered charity no. 1128267). AgeCo Limited registered office: One America Square, 17 Crosswall, London, EC3N 2LB (registered in England and Wales, no. 03156159).",
};
